const hu = {
  'home.eyebrow':         '🌍 geoplay24.com',
  'home.title':           'Geo Play 24',
  'home.subtitle.line1':  '7 magával ragadó földrajz-játék.',
  'home.subtitle.line2':  '1 Föld. 5 szint. Végtelen csoda.',
  'home.tagline.line1':   'Hét játék, egy bolygó.',
  'home.tagline.line2':   'Fedezd fel a Föld minden zugát — versenyezz, gyűjts pontot, hódíts birodalmat.',
  'home.footer.company':  'Cég',
  'home.footer.legal':    'Jogi',
  'home.footer.about':    'Rólunk',
  'home.footer.contact':  'Kapcsolat',
  'home.footer.github':   'GitHub',
  'home.footer.tiktok':   'TikTok',
  'home.footer.x':        'X / Twitter',
  'home.footer.privacy':  'Adatvédelem',
  'home.footer.terms':    'Felhasználási feltételek',
  'home.footer.cookies':  'Sütik',
  'home.copy':            'powered by: © 2026 Janek @ DevFlow C ™️',
  'home.beta.title':      'Csatlakozz az Android appunk korai tesztelőihez',
  'home.beta.text':       'Kapj Founder jelvényt, lifetime Premiumot és esélyt a fenti sorsolt díjakra.',
  'home.beta.cta':        'BETA program',

  'common.start':         'Indítás',
  'common.startBig':      '▶ Indítás',
  'common.back':          'Vissza',
  'common.home':          'Főoldal',
  'common.howToPlay':     'Hogyan játssz',
  'common.gotIt':         'Értem — vissza a játékhoz',
  'common.next':          'Tovább',
  'common.restart':       'Újrakezdés',
  'common.tryAgain':      'Próbáld újra',
  'common.playAgain':     'Játssz újra',
  'common.mainMenu':      'Főmenü',
  'common.quit':          'Kilépés',
  'common.play':          'Játssz',
  'common.unlock':        '🔒 Nyisd meg Premiummal',
  'common.language':      'Nyelv',

  'rules.kicker.goal':         'Cél',
  'rules.kicker.howToPlay':    'Hogyan játssz',
  'rules.kicker.levels':       'Szintek',
  'rules.kicker.tips':         'Tippek',
  'rules.gameNotFound':        'A játék nem található',
  'rules.points':              'pont',

  'games.origin.title':       'Origin Hunt',
  'games.origin.tagline':     'Találd meg a gyökereid',
  'games.origin.description': 'Egy véletlenszerű Street View hely a világban. Tűzd ki magad a térképen. 100 km → 1 km pontosság öt szinten át.',
  'games.hunt.title':         'Object Hunt',
  'games.hunt.tagline':       'GPS-stílusú kincsvadászat',
  'games.hunt.description':   'Egy valódi nevezetesség közelébe dobnak. Sétálj el hozzá a Street View-ban. A iránytű egyre kevésbé segít, ahogy nőnek a szintek.',
  'games.photo.title':        'Photo Detective',
  'games.photo.tagline':      'Olvasd a nyomokat',
  'games.photo.description':  'Egy statikus Street View kép — nincs pásztázás, nincs mozgás. Olvasd a táblákat, növényzetet, naphelyzetet. 30 másodperctől 5 másodperces villanásig.',
  'games.pangaea.title':      'Pangaea Puzzle',
  'games.pangaea.tagline':    'Rakd össze a Földet',
  'games.pangaea.description':'Kontinensek és szigetek lebegnek egy 3D-s földgömb körül. Húzd vissza őket a helyükre — mai pozíció vagy az ősi Pangaea.',

  'rules.origin.goal': 'Egy véletlenszerű Street View helyre dobunk a Földön. Tűzd ki magad a világtérképen olyan pontosan, ahogy csak tudod.',
  'rules.origin.step1': 'Nézz körül a panorámán. Olvasd a táblákat, számold a sávokat, figyeld az ég állásából a napot.',
  'rules.origin.step2': 'Kattints a kis térképre, és tűzd ki, ahol szerinted vagy.',
  'rules.origin.step3': 'Küldd be. Minél közelebb a tűd a valódi helyhez, annál több pont.',
  'rules.origin.step4': 'A szintek láncolva — érd el a távolsági küszöböt a következőhöz.',
  'rules.origin.level1': '100 km-en belül',
  'rules.origin.level2': '50 km-en belül',
  'rules.origin.level3': '25 km-en belül',
  'rules.origin.level4': '10 km-en belül',
  'rules.origin.level5': '1 km-en belül',
  'rules.origin.tip1': 'A vezetés iránya, a rendszámformátum és az útburkolati jelek színe gyorsan elárulják az országot.',
  'rules.origin.tip2': 'A növényzet + napmagasság beszűkíti a szélességet. Az utcanév-táblák ráteszik a várost.',
  'rules.origin.tip3': 'A Master Geographer (L5 = 1 km) brutális — a legtöbb futam L3 vagy L4 szinten véget ér.',

  'rules.hunt.goal': 'Egy valódi nevezetesség közelébe rak a Street View. Sétálj el oda a panorámában, amíg a tetején nem állsz. Az iránytű egyre kevésbé segít magasabb szinteken.',
  'rules.hunt.step1': 'Olvasd el a célpont nevét a felső sávban.',
  'rules.hunt.step2': 'Az iránytű nyíl + távolságmérő alapján céloztasd magad.',
  'rules.hunt.step3': 'A nyilakra kattintva sétálj át a Street View-on.',
  'rules.hunt.step4': 'Ha a céltartományon belül vagy, az „Megtaláltam" gomb aktívvá válik — pontozáshoz nyomd meg.',
  'rules.hunt.level1': '5 km távol · 10 perc · világhírű · nyíl + pontos távolság · 100 m céltartomány',
  'rules.hunt.level2': '15 km · 12 perc · világhírű · nyíl + kerekített távolság',
  'rules.hunt.level3': '25 km · 12 perc · országosan ismert · csak iránytű, távolság nélkül',
  'rules.hunt.level4': '50 km · 15 perc · országosan ismert · forró/hideg jelzés',
  'rules.hunt.level5': '50 km · 10 perc · obskúr · csak a POI neve, GPS nélkül',
  'rules.hunt.tip1': 'L4–L5-ön 3 Compass Ping jár — nyíl-villanások, használd takarékosan.',
  'rules.hunt.tip2': 'Félút-bónusz: a félútnál +2 perc.',
  'rules.hunt.tip3': 'Ha csak a nevet kapod, idézd fel emlékből vagy figyeld a környéket — sok nevezetesség messziről is felismerhető.',

  'rules.photo.goal': 'Egy statikus Street View képet látsz — nincs pásztázás, nincs mozgás. A táblákból, növényekből, naphelyzetből és útburkolati jelekből kell kitalálnod, hol vagy a Földön.',
  'rules.photo.step1': 'Először régiót választasz (Világ, Európa, Ázsia stb.) — ez szabja meg a szénakazlat.',
  'rules.photo.step2': 'A kép villan egy fix megfigyelési idő erejéig. Használj ki minden másodpercet.',
  'rules.photo.step3': 'Az időzítő után térkép jelenik meg. Tűzd ki a legjobb tipped.',
  'rules.photo.step4': 'Közelebb tipp = több pont. Az eredmény-képernyőn újranézheted a képet, és látod, mit hagytál ki.',
  'rules.photo.level1': '30 mp megfigyelés · 1 000 km pontosság',
  'rules.photo.level2': '20 mp · 500 km',
  'rules.photo.level3': '15 mp · 250 km',
  'rules.photo.level4': '10 mp · 100 km',
  'rules.photo.level5': '5 mp villanás · 50 km',
  'rules.photo.tip1': 'A táblák nyelve a leggyorsabb nyom. Egy szó is gyakran kijelöli az országot.',
  'rules.photo.tip2': 'A nap iránya megmutatja, merre van dél (északi félteke) vagy észak (déli félteke).',
  'rules.photo.tip3': 'Az elektromos vezetékek formája, az útburkolati jelek és a rendszámok meglepően árulkodóak.',

  'rules.pangaea.goal': '3D-s Föld, hat kontinens. Tedd mindegyiket a szint tolerancia-szögén belülre — a mai pozíciójára vagy oda, ahol 300 millió éve volt a Pangaea idején.',
  'rules.pangaea.step1': 'Válassz kontinenst a jobb oldali listából.',
  'rules.pangaea.step2': 'Kattints a földgömbön, ahova szerinted tartozik.',
  'rules.pangaea.step3': 'Ha a tolerancián belül vagy → odapattan. Egyébként → piros visszajelzés, próbáld újra.',
  'rules.pangaea.step4': '3 próbálkozás kontinensenként. Legalább 5/6 elhelyezés a továbbjutáshoz.',
  'rules.pangaea.level1': 'Kontinensek · ma · 25° tolerancia',
  'rules.pangaea.level2': 'ma · 18° tolerancia',
  'rules.pangaea.level3': 'ma · 12° pinpoint',
  'rules.pangaea.level4': 'Pangaea · ősi · 25° tolerancia',
  'rules.pangaea.level5': 'Pangaea · ősi · 18° pinpoint',
  'rules.pangaea.tip1': 'Húzd a földgömböt a forgatáshoz. Görgetéssel zoomolj.',
  'rules.pangaea.tip2': 'Pangaea szinteken a kontinensek a déli féltekén tömörültek — Afrika és Dél-Amerika összeillenek, India Kelet-Afrikának támaszkodott, Észak-Amerika Európához simult.',
  'rules.pangaea.tip3': 'Az Antarktisz nagyjából az Egyenlítőnél volt. Ausztrália alulról kapaszkodott rá.',

  /* ─── Landmark Quiz ─── */
  'games.landmark.title':          'Landmark Quiz',
  'games.landmark.tagline':        'Ismerd fel a látnivalót',
  'games.landmark.description':    'Egy fotó egy híres épületről vagy emlékműről — ismerd fel, és tűzd ki a világtérképen.',
  'rules.landmark.goal':           'Egy híres látnivaló fotóját látod. Tűzd ki a világtérképen, hol van.',
  'rules.landmark.step1':          'Nézd a fotót pár másodpercig. Ismerd fel az épületet, figyeld a környezetet.',
  'rules.landmark.step2':          'Az időzítő letelte után megjelenik a világtérkép.',
  'rules.landmark.step3':          'Tűzz ki egy pint és küldd be. Minél közelebb, annál több pont.',
  'rules.landmark.step4':          'Öt szint. Mindegyik rövidebb és szigorúbb az előzőnél.',
  'rules.landmark.level1':         '30 mp megfigyelés · 1 000 km pontosság',
  'rules.landmark.level2':         '20 mp · 500 km',
  'rules.landmark.level3':         '15 mp · 250 km',
  'rules.landmark.level4':         '10 mp · 100 km',
  'rules.landmark.level5':         '5 mp villanás · 50 km',
  'rules.landmark.tip1':           'A jellegzetes alakok (Eiffel, Piramisok) pillanat alatt felismerhetők — a pont a pontos tűzésből jön.',
  'rules.landmark.tip2':           'Kevésbé híres épületeknél: figyeld a környezetet — éghajlat, építészet, háttér.',
  'rules.landmark.tip3':           'A képek a Wikipédiáról CC-BY-SA licenc alatt. A kredit-csempén megnézheted a forrást.',

  'paywall.title':        "Ez a játék Premium",
  'paywall.text':         "Ezt a játékot a játék közben gyűjtött pontokkal oldhatod fel.",
  'paywall.cta':          "Csatlakozz a BETA programhoz",
  'paywall.dismiss':      "Talán később",

  /* ─── Spot the Landmark ─── */
  'games.spot.title':       "Spot the Landmark",
  'games.spot.tagline':     "Feleletválasztós",
  'games.spot.description': "Egy híres épület vagy szobor fotója — válaszd ki a helyes választ 3-6 lehetőségből. Végtelen mód, minden kör nehezebb.",

  'rules.spot.goal':   "Nézd meg a fotót, válaszd ki a helyes nevezetességet. Egy rossz válasz véget vet a futamnak.",
  'rules.spot.step1':  "Válassz régiót (Világ, Európa, Ázsia…) — a pool a kontinensre szűkül.",
  'rules.spot.step2':  "Egy híres épület fotója jelenik meg kérdéssel.",
  'rules.spot.step3':  "Koppints a helyes válaszra a lehetőségek közül.",
  'rules.spot.step4':  "Tartsd életben a sorozatot — minden szint hozzáad egy választ (max 6) és nehezedik.",
  'rules.spot.level1': "L1–L3 · 3–5 választás · csak a név",
  'rules.spot.level2': "L4+ · 6 választás · csak a név",
  'rules.spot.level3': "L10+ · 6 választás · név + ország",
  'rules.spot.level4': "L20+ · 6 választás · név + város + ország",
  'rules.spot.level5': "Végtelen · pontszám a mélységgel arányos · egy hiba véget vet",
  'rules.spot.tip1':   "A téves válaszok ugyanarról a kontinensről jönnek — figyelj.",
  'rules.spot.tip2':   "Az ikonikus formák (Eiffel, piramisok) könnyűek — a pont a mélységből jön.",
  'rules.spot.tip3':   "L10 körül az ország is bekerül; L20-tól a város is.",

  "spot.region.title": "Hol akarsz játszani?",
  "spot.region.sub": "Válassz régiót. Híres nevezetességek jönnek — válaszd a helyes választ a továbbjutáshoz.",
  "spot.q.name": "Mi ez a nevezetesség?",
  "spot.q.namecountry": "Név + ország?",
  "spot.q.namecity": "Név + város + ország?",
  "spot.score": "Pont",
  "spot.choices": "választás",
  "spot.correct": "HELYES",
  "spot.wrong": "TÉVES",
  "spot.points": "PONT",
  "spot.runTotal": "Futam összesen",
  "spot.next": "Tovább →",
  "spot.youPicked": "Te választottad",
  "spot.finalScore": "VÉGSŐ PONTSZÁM",
  "spot.reachedLevel": "Eljutottál a szintig",
  "spot.tryAgain": "Újra ↺",
  "spot.changeRegion": "Régió csere",
  "spot.mainMenu": "Főmenü",

  /* ─── Auth ─── */
  "auth.signIn": "Belépés",
  "auth.eyebrow": "MINDFUL ZEN WORLD",
  "auth.title": "Belépés vagy regisztráció",
  "auth.subtitle": "Nincs jelszó — küldünk egy varázslinket emailben. Új vagy? Magától létrejön a fiók.",
  "auth.send": "Varázslink küldése",
  "auth.sending": "Küldés…",
  "auth.invalidEmail": "Adj meg egy érvényes email címet.",
  "auth.sendFailed": "Nem sikerült küldeni. Próbáld újra.",
  "auth.checkInbox": "Nézd meg a postafiókod",
  "auth.linkSentTo": "Belépő link úton van ide:",
  "auth.spamHint": "Nem találod? Nézz a spam mappába. A link 1 órán belül lejár.",
  "auth.gotIt": "Rendben",
  "auth.fineprint": "A folytatással elfogadod a Felhasználási Feltételeket és az Adatvédelmi Nyilatkozatot.",
  "auth.menu.profile": "Profilom",
  "auth.menu.admin": "Admin",
  "auth.menu.signOut": "Kilépés",
  "auth.callback.signingIn": "Beléptetés folyamatban…",
  "auth.callback.hold": "Csak egy pillanat.",
  "auth.callback.welcome": "Üdvözlünk",
  "auth.callback.redirecting": "Visszaviszünk a játékokhoz…",
  "auth.callback.problem": "Valami hiba történt",

  /* ─── Auth ─── */

  /* ─── Profile ─── */
  "profile.title": "Profilom",
  "profile.totalPoints": "Összes pont",
  "profile.totalRuns": "Játszott futamok",
  "profile.gamesPlayed": "Kipróbált játékok",
  "profile.editTitle": "Profil szerkesztése",
  "profile.displayName": "Megjelenített név",
  "profile.avatar": "Avatar",
  "profile.country": "Ország (opcionális)",
  "profile.countryHint": "Kétbetűs ISO kód, pl. HU, US, JP. Ranglista zászlóhoz használjuk.",
  "profile.save": "Mentés",
  "profile.saving": "Mentés…",
  "profile.saved": "Mentve",
  "profile.nameTooShort": "A név legalább 2 karakter legyen.",
  "profile.perGame": "Legjobb játékonként",
  "profile.noRuns": "Még nem játszottál — menj vissza a menübe és válassz egy játékot.",

  /* ─── Profile ─── */

  /* ─── Gating + Anon limit ─── */
  "common.locked": "ZÁROLVA",
  "common.needPoints": "KELL {n} PT",
  "locked.pill": "ZÁROLVA",
  "locked.title": "{game} zárolva",
  "locked.text": "{remaining} ponttal vagy a feloldástól. Játssz a már elérhető játékokkal — minden futam pontot ad a következő feloldáshoz.",
  "locked.dismiss": "Értem",
  "spot.anon.playsLeft": "{n} ingyen játék maradt — lépj be a folytatáshoz.",
  "spot.anon.title": "Elfogytak az ingyen játszmáid",
  "spot.anon.text": "{used}/{limit} ingyen játszmát használtál fel. Lépj be a folytatáshoz — ingyenes, jelszó nélkül, csak egy email link kell. A pontjaid mostantól a profilodba kerülnek.",
  "spot.anon.signIn": "Belépés a folytatáshoz →",
  "spot.anon.back": "Vissza a menübe",

  /* ─── Gating + Anon limit ─── */

  /* ─── Next game banner ─── */
  "rules.next.upcoming": "KÖVETKEZŐ",
  "rules.next.unlocked": "KÖVETKEZŐ — FELOLDVA",
  "rules.next.unlockedHint": "Elég pontod van — vissza a menübe és játssz.",
  "rules.next.needMore": "{remaining} pt kell még a feloldáshoz — folytasd a játékot.",
  "rules.next.signedOut": "Szerezz {threshold} pontot a feloldáshoz — lépj be hogy számoljanak a pontok.",
  "rules.next.premiumHint": "Premium szinttel oldódik fel — Android béta indulásával.",

  /* ─── Next game banner ─── */

  /* ─── Audio Atlas ─── */
  'games.audio.title':       "Audio Atlas",
  'games.audio.tagline':     "Zászló + himnusz",
  'games.audio.description': "Egy nemzeti himnusz szól, közben látod az ország zászlaját. Szúrd le a fővárost a térképen.",

  'rules.audio.goal':   "Egy nemzeti himnuszt hallasz és látod az ország zászlaját. Szúrd le a fővárost a világtérképen, minél pontosabban.",
  'rules.audio.step1':  "Válassz régiót. A pool a kontinensre szűkül.",
  'rules.audio.step2':  "A himnusz automatikusan elindul. A zászló végig kint marad.",
  'rules.audio.step3':  "Amikor a számláló nullára ér, megjelenik a térkép. Szúrj egy pin-t a fővárosra.",
  'rules.audio.step4':  "Akkor mész tovább, ha a távolság-küszöbön belül vagy. Magasabb szint = rövidebb hallgatás.",
  'rules.audio.level1': "10 mp hallgatás · 1 000 km-en belül",
  'rules.audio.level2': "8 mp · 500 km",
  'rules.audio.level3': "6 mp · 250 km",
  'rules.audio.level4': "4 mp · 100 km",
  'rules.audio.level5': "3 mp villanás · 50 km",
  'rules.audio.tip1':   "A zászló felismerése a könnyű rész — a főváros pontos helye a tényleges teszt.",
  'rules.audio.tip2':   "Néhány főváros nem a legnagyobb város (Brazília, Canberra, Ottawa, Pretoria) — figyelj.",
  'rules.audio.tip3':   "A himnuszok ritmusa és hangszerelése segíthet ha a zászló nem ismerős.",

  "audio.region.title": "Hol akarsz figyelni?",
  "audio.region.sub": "Válassz régiót. Egy nemzeti himnuszt hallasz és látod az ország zászlaját — szúrd le a fővárost a térképen.",
  "audio.empty.title": "Még nincs hang-clip a poolban",
  "audio.empty.text": "Még nincsenek elérhető himnuszok — a poolt kurálás alatt. Nézz vissza hamarosan új országokért.",
  "audio.listen.hint": "Ráismersz a zászlóra és himnuszra? Szúrd le a fővárost a térképen.",
  "audio.listen.skip": "Eleget hallottam →",
  "audio.submit.ready": "Tipp leadása →",
  "audio.submit.empty": "Kattints a térképre a pin elhelyezéshez",
  "audio.changeRegion": "Régió csere",

  /* ─── Empire ─── */
  "profile.empire.title": "Birodalmam",
  "profile.empire.empty": "Azonosíts egy országot az Audio Atlas-ban vagy Landmark Quiz-ben hogy megszerezd. A birodalmad minden helyes válasszal nő.",

  /* ─── Empire ─── */

  /* ─── Boost / Shop ─── */
  "boost.title": "Elkerülöd a grindelést",
  "boost.tagline": "Vásárolj pontot, oldj fel gyorsabban",
  "boost.description": "Nem akarsz várni a következő szintre? Három csomag €2.99-tól. A pont azonnal beszámít az egyenlegedbe és minden feloldásba.",
  "boost.cta": "Igen ezt kérem",
  "shop.title": "Pont bolt",
  "shop.sub": "Elkerülöd a grindelést",
  "shop.buy": "Kérem",
  "shop.opening": "Megnyitás…",
  "shop.success": "Fizetés rendben — a pont másodperceken belül megérkezik.",
  "shop.cancel": "Vásárlás megszakítva — nem terheltünk semmit.",
  "shop.fineprint": "Egyszeri vásárlás Stripe-on keresztül. A pontok a fizetés visszaigazolása után azonnal megérkeznek. Nincs előfizetés, nincs auto-megújítás.",
  "shop.boost.badge": "Népszerű",
  "shop.power.badge": "Legjobb ár",

  /* ─── Boost / Shop ─── */
};

export default hu;
